var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 552,
    viewBox: "0 0 431 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.745 114.226L429.897 138.6L383.749 94.103H300.745V114.226Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.822 313.04C205.207 379.225 207.591 445.424 209.961 511.61C206.743 513.75 201.688 517.728 197.695 524.292C190.8 535.639 191.72 547.043 192.194 550.921H326.216C328.528 545.722 336.557 526.044 327.91 509.915C316.635 488.887 279.895 479.178 243.226 497.764C240.353 436.189 237.466 374.615 234.593 313.04H202.808H202.822Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.862 313.039C173.01 379.224 158.159 445.424 143.307 511.609C146.525 513.749 151.581 517.727 155.574 524.291C162.468 535.638 161.549 547.042 161.075 550.92H27.0384C25.0994 546.669 16.5246 526.762 25.3436 509.914C36.2739 489.044 70.7165 478.947 104.642 495.235C122.495 434.493 140.334 373.766 158.188 313.025H187.862V313.039Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.42 331.921L178.085 355.828L144.92 359.921L155.169 327.921L183.42 331.921Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.936 353.888L205.482 365.422L204.414 335.374L233.873 331.267L235.936 353.888Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.337 257.856C101.744 269.821 77.2267 285.462 45.6997 286.424C42.6978 286.511 5.71293 287.272 1.31783 273.297C-1.56915 264.147 11.5587 255.113 30.7908 231.73C45.8721 213.403 56.1991 196.612 62.7487 184.834",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.337 257.856C101.744 269.821 77.2267 285.462 45.6997 286.424C42.6978 286.511 5.71293 287.272 1.31783 273.297C-1.56915 264.147 11.5587 255.113 30.7909 231.73C45.8721 213.403 56.1991 196.612 62.7487 184.834",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.977 34.4246C102.833 48.8739 21.983 188.397 76.4047 279.459C123.314 357.953 243.95 355.597 313.424 325.464C373.505 299.395 425.183 239.615 413.736 218.171C405.678 203.105 366.941 207.959 335.558 214.408C336.06 199.83 335.644 182.81 333.317 163.98C330.588 141.875 325.891 122.714 320.965 107.044C314.07 95.2379 291.276 59.6893 245.674 42.5398C239.957 40.3853 208.674 29.0528 179.991 34.4246H179.977Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.665 196.684H110.68C127.235 196.684 140.655 183.263 140.655 166.708V161.279C140.655 144.724 127.235 131.303 110.68 131.303H110.665C94.11 131.303 80.6894 144.724 80.6894 161.279V166.708C80.6894 183.263 94.11 196.684 110.665 196.684Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M107.79 181.502C115.247 181.502 121.291 172.911 121.291 162.313C121.291 151.715 115.247 143.124 107.79 143.124C100.334 143.124 94.2888 151.715 94.2888 162.313C94.2888 172.911 100.334 181.502 107.79 181.502Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.346 137.35L107.204 152.518L124.813 149.631L112.346 137.35Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.398 198.336H165.412C181.968 198.336 195.388 184.915 195.388 168.36V162.931C195.388 146.376 181.968 132.955 165.412 132.955H165.398C148.843 132.955 135.422 146.376 135.422 162.931V168.36C135.422 184.915 148.843 198.336 165.398 198.336Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.528 183.169C169.985 183.169 176.03 174.577 176.03 163.98C176.03 153.382 169.985 144.791 162.528 144.791C155.072 144.791 149.027 153.382 149.027 163.98C149.027 174.577 155.072 183.169 162.528 183.169Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.08 139.017L161.938 154.184L179.548 151.298L167.08 139.017Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.211 109.5L167.683 105.216C163.125 104.386 158.758 107.408 157.928 111.965L157.57 113.929C156.74 118.487 159.762 122.855 164.32 123.684L187.848 127.969C192.405 128.799 196.773 125.777 197.603 121.219L197.96 119.255C198.79 114.697 195.768 110.33 191.211 109.5Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0602 121.419L120.673 117.119C125.207 116.294 128.213 111.949 127.388 107.415L127.015 105.366C126.189 100.831 121.844 97.825 117.31 98.6506L93.6972 102.95C89.1629 103.776 86.1565 108.121 86.9822 112.655L87.3553 114.704C88.1809 119.238 92.526 122.245 97.0602 121.419Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M295.855 101.644C324.539 103.755 359.699 109.701 397.532 124.237C409.195 128.718 419.981 133.587 429.877 138.586C429.662 129.408 427.536 122.197 424.822 116.553C409.266 84.1783 358.119 69.5998 297.105 77.6287C296.689 85.629 296.272 93.6292 295.855 101.629V101.644Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.231 76.4366C134.795 17.8209 197.533 -11.4798 249.829 5.8852C292.473 20.0472 322.693 63.438 322.621 113.048C290.046 101.658 250.203 90.613 204.126 83.6756C170.387 78.6054 139.449 76.6521 112.231 76.4366Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.658 61.4556C150.412 40.6866 170.348 31.0203 183.318 36.2197C192.827 40.0403 199.362 52.1771 198.399 65.7645C180.819 64.3282 163.239 62.8919 145.658 61.4556Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.144 59.7754C146.227 61.7719 172.31 63.7683 198.408 65.7648C209.281 64.7881 216.994 70.5477 217.425 76.0775C217.77 80.4439 213.533 84.1064 212.441 84.9826",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M367.671 199.091L174.352 275.592L189.684 314.336L383.003 237.835L367.671 199.091Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M349.68 206.896L356.129 223.199",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.083 213.345L340.532 229.632",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M318.3 219.292L324.749 235.594",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.564 225.396L309.013 241.698",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.799 231.414L293.248 247.716",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M271.088 237.561L277.537 253.849",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M255.569 244.197L262.018 260.499",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M239.853 250.287L246.302 266.589",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.477 257.31L230.926 273.612",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M209.101 264.32L215.55 280.608",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.336 270.338L199.785 286.626",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.229 212.397C222.123 249.339 244.63 277.103 273.485 284.083C289.673 288.004 313.501 287.128 319.045 275.868C322.607 268.643 317.02 260.499 303.547 235.594C293.019 216.117 284.904 199.786 279.46 188.497",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M215.229 212.397C222.123 249.339 244.63 277.103 273.485 284.083C289.673 288.004 313.501 287.128 319.045 275.868C322.607 268.643 317.02 260.499 303.547 235.594C293.019 216.117 284.904 199.786 279.46 188.497",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M135.792 184.016C110.973 185.51 83.3097 189.259 81.8878 199.729C81.2989 204.11 85.4785 208.218 88.7102 211.378C106.578 228.886 133.121 222.236 139.168 220.556",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M135.792 184.016C110.973 185.51 83.3097 189.259 81.8878 199.729C81.2989 204.11 85.4785 208.218 88.7102 211.378C106.578 228.886 133.121 222.236 139.168 220.556",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M135.1 205.906C130.676 206.882 125.778 207.644 120.45 207.96C104.765 208.879 91.5368 205.59 81.9998 202.071",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen1);
export default __webpack_public_path__ + "static/media/screen1.b9f84d3248a4d3612c4331687808ab98.svg";
export { ForwardRef as ReactComponent };